/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_Manifest_InvalidInputs */



/**
* | output |
* | --- |
* | "Manifest no longer valid" |
*
* @param {Partner_Connectors_Manifest_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_manifest_invalid = /** @type {((inputs?: Partner_Connectors_Manifest_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_Manifest_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Manifest nicht mehr gültig")
	return /** @type {LocalizedString} */ ("Manifest no longer valid")
});